import { Image, Text } from '$components'
import { ElementType } from 'react'

export type NameCellProps = {
  data: {
    name: string,
    imageUrl: string,
    fallbackIcon: ElementType,
  }
}

export function NameCell({ data }: NameCellProps) {

  return (
    <div className="flex gap-stack-tight items-center w-fit">
      <Image
        src={data.imageUrl}
        alt={data.name}
        size="sm"
        rounding="full"
        fallbackIcon={data.fallbackIcon}
      />

      <Text type="s" className="text-nowrap truncate max-w-32">
        { data.name }
      </Text>
    </div>
  )
}
